import { baseApi } from "./base.api";
import { IProfile } from "../types/profile/IProfile";
import {IProfileRes} from "../types/profile/IProfileRes";
export const profileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getprofile: builder.query<IProfile, void>({
      query: () => ({
        url: "/auth/profile",
        method: "GET",
      }),
      transformResponse: (response : IProfileRes) => response.data,
    }),
  }),
});

export const { useGetprofileQuery  } = profileApi;
